import { render, staticRenderFns } from "./ServiceCompensationTabService.vue?vue&type=template&id=c1b6cc9a&scoped=true"
import script from "./ServiceCompensationTabService.vue?vue&type=script&lang=js"
export * from "./ServiceCompensationTabService.vue?vue&type=script&lang=js"
import style0 from "./ServiceCompensationTabService.vue?vue&type=style&index=0&id=c1b6cc9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b6cc9a",
  null
  
)

export default component.exports